export const capitalize = (str: string) =>
  `${str.charAt(0).toUpperCase()}${str.slice(1, str.length).toLowerCase()}`;

export const replaceAt = (str: string, index: number, replace: string) =>
  str.substring(0, index) + replace + str.substring(index + 1);

export const trim = (str: string) => str.replace(/^\s+|\s+$/g, '');
